import React from "react";
import { NumberCard } from "../../../UI/components/NumberCard";
import { gql } from "apollo-boost";
import { useQuery, useSubscription } from "@apollo/react-hooks";

const BLOCK_HEIGHT_QUERY = gql`
  query newBlocks {
    blocks_public(limit: 1, order_by: { height: desc }) {
      id
      height
    }
  }
`;

export const BlockHeightCard: React.FC = () => {
  const { data, loading, error } = useQuery(BLOCK_HEIGHT_QUERY, {
    fetchPolicy: "cache-only",
  });

  const blockHeight =
    data &&
    data.blocks_public &&
    data.blocks_public[0] &&
    data.blocks_public[0].height
      ? data.blocks_public[0].height
      : 0;

  return (
    <>
      <NumberCard
        data={(+blockHeight).toLocaleString()}
        icon={"fas fa-angle-double-up"}
        title={"Blockheight"}
        loading={loading}
        error={!!error}
      />
    </>
  );
};
